//#region imports
import React from 'react';
import { WINNERS } from 'configs/constants';
import styles from './styles';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Container from '@mui/material/Container';
import WinnerCard from 'components/Card/Winner';
import Typography from '@mui/material/Typography';
import useMobile from 'hooks/useMobile';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
//#endregion

interface IProps {
  className?: string;
  onSubscribe: () => void;
}

const Winners: React.FC<IProps> = ({ className, onSubscribe }) => {
  const { t } = useTranslation();
  const classes = styles();

  const { isMobile } = useMobile();

  return (
    <Container className={ cn(className, classes.root, 'slim') } >
      <Typography
        variant="h2"
        fontSize={ isMobile ? 26 : 30 }
        color="inherit"
        mb={ isMobile ? 4 : 8 }
        lineHeight={ 1 }
        dangerouslySetInnerHTML={ { __html: t('winners.title') } }
      />
      <Swiper
        className={ classes.slider }
        navigation
        pagination={ { dynamicBullets: true, enabled: isMobile } }
        modules={ [Navigation, Pagination] }
        spaceBetween={ isMobile ? 12 : 20 }
        slidesPerView={ 'auto' }
        centeredSlides={ isMobile }
      >
        { WINNERS.map((winner, index) => (
          <SwiperSlide key={ winner.name } virtualIndex={ index } style={ { width: 270 } }>
            <WinnerCard
              headerLabel={ t(winner.town) }
              title={ winner.name }
              onClick={ onSubscribe }
            />
          </SwiperSlide>
        )) }
      </Swiper>
    </Container>
  );
};

export default Winners;
